import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import SelectOptions from "components/SelectOptions"
//Import Images
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import RattingService from "services/SalesDeveloper/RattingService";
import CriteriaService from "services/SalesDeveloper/CriteriaService";

function EditRateModal({ 
    modal, toggle, add,getList, editRate, setShowSuccessModal, deletedRatesList, setDeletedRatesList }) {
    const rattingService = new RattingService()
    const [loading, setLoading] = useState(false)
    const [totalRate, setTotalRate] = useState(0)
    const [craterialOptions, setCrateriaOptions] = useState([])
    const filterData = useSelector(state => state.adminFilter)
    const [ratesData, setRatesData] = useState(add ? [{
        rate: "",
        rating_criteria: null
    }
    ] : [])

    useEffect(() => {
         if (!add) {
            const craterias = editRate.craterias.map(rate => {
                
                return {
                    id: rate?.id,
                    rate: rate?.rate,
                    rating_criteria: rate?.rating_criteria
                }
            })

            setRatesData(craterias)
        }
    }, [editRate])

    const hasCrateria = ratesData.some(
        (item) => item.rating_criteria === null || item.rating_criteria === undefined
    );

    const handleValidSubmit = () => {
        if (hasCrateria) {
            toast.error("please select criteria")
            return
        }
        // setLoading(true)
        const craterias = ratesData.map(rate => {
            if (rate.rate !== "") {
                return {
                    criteria_id: rate.rating_criteria.value,
                    rate: rate.rate
                }
            } else {
                return {
                    criteria_id: rate.rating_criteria.value,
                    rate: 50
                }
            }
        })

        const data = {
            compound_id: filterData?.compound_id,
            rates: craterias
        }
        if (!add) {
            rattingService.update(filterData?.developer_id, data).then(response => {
                if (response && response.status === SuccessOk) {
                    toast.success(response.data.success)
                    toggle()
                    getList(true)
                }else {
                    setLoading(false)
                  }
            })
            // Promise.all(
            //     deletedRatesList.map(async (deletedItem) => {
            //         await rattingService.remove(deletedItem)
            //     }),
            // ).then(() => {
            //     rattingService.update(filterData?.developer_id?.value, data).then(response => {
            //         if (response && response.status === SuccessOk) {
            //             toast.success(response.data.success)
            //             getList()
            //             toggle()
            //         }else {
            //             setLoading(false)
            //           }
            //     })
            // })

        } else {
            rattingService.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    setLoading(false)
                    toggle()
                    setShowSuccessModal(true)
                }else {
                    setLoading(false)
                  }
            })
        }

    }
    const deleterHandelr = (rate, index) => {
        if (rate ?.id) {
            const updatedData = ratesData.filter((item, index2) => {
                return index !== index2
            })
            setDeletedRatesList((list) => [...list, rate.id])
            setRatesData([...updatedData])
        } else {
            const updatedData = ratesData.filter((item, index2) => {
                return index !== index2
            })
            setRatesData([...updatedData])
        }
    }
    const getTotalRate = () => {
        let sum = 0
        ratesData.forEach(item => {
            if (!isNaN(item.rate) && !!item.rate) {
                sum = sum + item.rate
            } else {
                sum = sum + 50
            }


        })
        let rate = ratesData ?.length === 0 ? sum / 1 : sum / ratesData ?.length
        
        setTotalRate(rate)
        // return 
    }

    useEffect(()=>{
        getTotalRate()
    },[ratesData])

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
            {add ? "Add New Rate":"Edit Rate"}   
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit();
                    }}>
                    {ratesData.map((rate, index) => {
                        return (
                            <Row key={index}>
                                {index >= 1 && <Row >
                                    <Col md={12} className="d-flex flex-row-reverse">
                                        <button type="button"
                                            className="btn btn-danger m-0 py-1 px-2"
                                            onClick={() => deleterHandelr(rate, index)}  >X</button>
                                    </Col>
                                </Row>}
                                <Col md={6}>
                                    <SelectOptions
                                        label='Criteria'
                                        placeholder='Select'
                                        options={craterialOptions.filter(({ label: l1 }) => !ratesData.some(({ rating_criteria }) => l1 === rating_criteria ?.label))}
                                        handleSelectChange={(data) => {
                                            const updated = ratesData.map((item, itemIndex) => {
                                                if (index === itemIndex) {
                                                    return { ...item, rating_criteria: data }
                                                }
                                                return item
                                            })
                                            setRatesData([...updated])
                                        }}
                                        selectedOption={rate.rating_criteria}
                                        Service={CriteriaService}
                                        setOptions={(options) => {
                                            setCrateriaOptions(options)
                                        }}
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <AvField
                                        name={"rate"}
                                        label={"Rate"}
                                        bsSize="lg"
                                        value={rate.rate}
                                        onChange={e => {
                                            const value = !!e.target.value ?  parseInt(e.target.value) : null
                                            const updated = ratesData.map((item, itemIndex) => {
                                                if (index === itemIndex) {
                                                    return { ...item, rate: value }
                                                }
                                                return item
                                            })
                                            setRatesData([...updated])
                                        }}
                                        required={false}
                                        placeholder={"rate Default 50%"}
                                        type={"number"}
                                        min={"1"}
                                        max={"100"}
                                    />
                                </Col>
                            </Row>
                        )
                    })}
                    {ratesData?.length < craterialOptions?.length && <Row>
                        <Col>
                            <button 
                            type="button"
                             onClick={() => {
                                setRatesData([...ratesData, {
                                    rate: "",
                                    rating_criteria: null
                                }])
                            }} 
                            className="btn-hover"
                            style={{ background: "none", border: "none", color: "green", opacity: ".6" }}
                            disabled={loading ? true : false}
                            ><i className="fas fa-plus-circle"></i>Add New Rate</button>
                        </Col>
                    </Row>}
                    <Row className="mt-2">
                        {/* <p className="fw-bold font-size-18">Total Rate : {getTotalRate(ratesData).toFixed(2)}%</p> */}
                        <p className="fw-bold font-size-18">Total Rate : {totalRate.toFixed(2)}%</p>
                    </Row>
                    <ModalFooter className="px-0">
                    <button type='submit' className='btn btn-success w-100'>
                           {  add ? "Add Rate" : "Update Rate" }
                        </button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal >
    );
}

export default EditRateModal;
